import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-striped table-sm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "align-middle text-center small" }
const _hoisted_5 = { class: "align-middle" }
const _hoisted_6 = { class: "text-center text-nowrap" }
const _hoisted_7 = { class: "mx-4" }
const _hoisted_8 = { class: "align-middle small" }
const _hoisted_9 = { class: "align-middle text-end" }
const _hoisted_10 = { class: "d-flex text-nowrap" }
const _hoisted_11 = {
  class: /*@__PURE__*/_normalizeClass('flex-fill me-4 ')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
        _createElementVNode("tr", { class: "fw-bold" }, [
          _createElementVNode("th", { class: "col-2 text-center" }, "Fecha"),
          _createElementVNode("th", { class: "col-1 text-center" }, "Tipo"),
          _createElementVNode("th", { class: "col-4" }, "Concepto"),
          _createElementVNode("th", { class: "col-3 col-xl-2 text-center" }, "Valor")
        ])
      ], -1)),
      (_ctx.gtrpoints?.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gtrpoints, (c) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: c._id
              }, [
                _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.formatDate(c._id)), 1),
                _createElementVNode("td", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.typeIconClass(c.type))
                      }, null, 2)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_8, _toDisplayString(c.source), 1),
                _createElementVNode("td", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.toTwoDecimals(c.amount)), 1)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}